/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Play30 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={30} height={30} viewBox="0 0 30 30" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={15} cy={15} r={15} />
      <path fill="currentColor" d="m11 7 13 8-13 8z" />
    </g>
  </svg>
);

export const __descriptor_Play = {
  name: "Play",
  instances: [{ size: 30, Component: Play30 }],
} as const;
